var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"formContainer"},[_c('user-log-table',{attrs:{"users":_vm.users,"totalPages":_vm.totalPages,"page":_vm.page,"setSkeletonLoader":_vm.displayLoader},on:{"setPage":_vm.setPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }